const baseURL = process.env.NEXT_PUBLIC_LOCAL_API_URL;
const payURL = process.env.NEXT_PUBLIC_NEXTAUTH_URL;

export const GET_PLANS = `/plans/pricing`;
export const GET_TERMS = `/privacy-terms`;
export const GET_FAQ = `/faqs`;
export const GET_TOOL_BANNER = `/tool-banner`;
export const BLOG = `/blog`;
export const SINGLE_BLOG = `/blog/show`;
//new
export const POST_WEB_SEARCH = `/search/web-search`; //post web api
export const POST_WEB_SEARCH_COPY_GENERATOR = `/search/web-search-copy-generator`;
export const GET_PLATEFORMS_TYPES = `/brand/get-platform`;

// finger print use unique detaila
export const GET_DEVICE_USAGES = `${baseURL}/track-usage`;
export const PAYPAL_PAYMENT = `${baseURL}/paypal/subscription/create`;
export const DEFAULT_REDIRECT = `${payURL}`;
